import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import Page from './page';
import ButtonNext from './ButtonNext';
import TagCloud from 'react-tag-cloud';
import Api from '../../util/api';
import ResultCloudResultSet from '../../util/ResultCloudResultSet';
import {publicBuildUrl} from '../../config/config';

const ResultCloud = ({navigateDeviceNext = false, id, level}) => {
    const [data, setData] = useState(null);

    const getRandomSize = () => Math.floor(Math.random() * 40) + 25;
    const getRandomColor = () => {
        const colors = [
            '#0D4553',
            '#1D7C70',
            '#E12365',
            '#C21D51',
        ];

        return colors[Math.floor(Math.random() * colors.length)]
    }

    useEffect(() => {
        const fetchData = async () => {
            let response = await Api.getData(id);

            setData(ResultCloudResultSet.fromResponse(response));
        }

        fetchData().then();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    if (data === null) {
        return <Page title={'Loading'}>Loading ...</Page>;
    }

    return (
        <Page title={'Target Group Selection'}>
            <div className={'bodyContainer'} style={{justifyContent: 'center'}}>
                <div style={styles.container}>
                    <div style={styles.title}>Samen maken we het verschil!</div>
                    <div style={styles.resultContainer}>
                        <TagCloud
                            style={{
                                ...styles.tag,
                                fontSize: () => getRandomSize(),
                                color: () => getRandomColor(),
                            }}
                            spiral={'archimedean'}>
                            {data.map((answer, index) => <div key={index}>{answer}</div>)}
                        </TagCloud>
                    </div>

                    <div style={styles.navigationContainer}>
                        <ButtonNext navigateDeviceNext={navigateDeviceNext}/>
                    </div>
                </div>
                <div style={styles.animationContainer}>
                    <img src={`${publicBuildUrl}animations/DiscussionHappyLevel` + level + '.gif'} alt={'Happy'} style={{width: '500px'}}/>
                </div>
            </div>
        </Page>
    );
}

ResultCloud.propTypes = {
    navigateDeviceNext: PropTypes.bool,
    id: PropTypes.number.isRequired,
    level: PropTypes.number.isRequired,
}

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '960px',
        position: 'relative'
    },
    resultContainer: {
        display: 'flex',
        width: '100%',
        justifyContent: 'space-between',
        position: 'relative',
        height: '500px',
    },
    columnLeft: {
        display: 'flex',
        width: 'calc(50% - 25px)',
        justifyContent: 'center',
        alignItems: 'center',
    },
    columnRight: {
        display: 'flex',
        flexDirection: 'column',
        width: 'calc(50% - 25px)',
    },
    title: {
        borderBottom: '9px solid #68c4d6',
        color: '#e4195f',
        display: 'flex',
        justifyContent: 'center',
        fontFamily: 'Ubuntu',
        fontWeight: 'bold',
        fontSize: '48px',
        lineHeight: '48px',
        fontStyle: 'italic',
        paddingBottom: '25px',
        marginBottom: '105px',
        width: '100%',
    },
    question: {
        color: '#427A83',
        width: '100%',
        fontFamily: 'Ubuntu',
        fontWeight: 'bold',
        fontSize: '22px',
        marginBottom: '25px',
        textAlign: 'center',
    },
    navigationContainer: {
        marginTop: '40px',
        width: '100%'
    },
    animationContainer: {
        position: 'absolute',
        bottom: 0,
        right: '50%',
    },
    tag: {
        fontFamily: 'sans-serif',
        fontWeight: 'bold',
        fontStyle: 'italic',
        padding: 5,
        width: '100%',
        height: '100%',
        textShadow: '1px 1px rgba(150,150,150, 0.5)',
    }
}

export default ResultCloud;
